import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react'

const config = defineConfig({
  theme: {
    tokens: {
      colors: {
        hep: {
          0: { value: '#ffffff' },
          50: { value: '#f5eaff' },
          100: { value: '#d9c6ee' },
          200: { value: '#bea1de' },
          300: { value: '#a47cd0' },
          400: { value: '#8a56c2' },
          500: { value: '#713ca8' },
          600: { value: '#582f83' },
          700: { value: '#3f225f' },
          800: { value: '#26133a' },
          900: { value: '#100519' },
          inactive: { value: '#A0AEC0' },
        },
        hep_blue: {
          50: { value: '#dff5ff' },
          100: { value: '#b3ddfe' },
          200: { value: '#85c6f9' },
          300: { value: '#58aff6' },
          400: { value: '#2e98f1' },
          500: { value: '#1b7fd8' },
          600: { value: '#1063a9' },
          700: { value: '#075491' },
          800: { value: '#002a4b' },
          900: { value: '#000f1d' },
        },
        hep_orange: {
          50: { value: '#ffebe3' },
          100: { value: '#f7ccbb' },
          200: { value: '#ecaa93' },
          300: { value: '#e2896a' },
          400: { value: '#d86840' },
          500: { value: '#bc4d26' },
          600: { value: '#953c1d' },
          700: { value: '#6b2a13' },
          800: { value: '#431809' },
          900: { value: '#1d0500' },
        },
        hep_green: {
          50: { value: '#e7faec' },
          100: { value: '#c6ebd2' },
          200: { value: '#a3dcb6' },
          300: { value: '#7fce9a' },
          400: { value: '#5cbf7d' },
          500: { value: '#44a663' },
          600: { value: '#33814d' },
          700: { value: '#215633' },
          800: { value: '#123720' },
          900: { value: '#001406' },
        },
      },
      fonts: {
        body: { value: 'Poppins, sans-serif' },
        heading: { value: 'Poppins, sans-serif' },
      },
      fontWeights: {
        normal: { value: 400 },
        medium: { value: 600 },
        bold: { value: 700 },
      },
      shadows: {
        outline: { value: '0 0 0 3px transparent' },
      },
    },
    semanticTokens: {
      colors: {
        hep: {
          solid: { value: '{colors.hep.500}' },
          contrast: { value: '{colors.hep.0}' },
          fg: { value: '{colors.hep.700}' },
          muted: { value: '{colors.hep.100}' },
          subtle: { value: '{colors.hep.200}' },
          emphasized: { value: '{colors.hep.300}' },
          focusRing: { value: '{colors.hep.500}' },
          inactive: { value: '{colors.hep.inactive}' },
        },
        hep_blue: {
          solid: { value: '{colors.hep_blue.500}' },
          contrast: { value: '{colors.hep_blue.100}' },
          fg: { value: '{colors.hep_blue.700}' },
          muted: { value: '{colors.hep_blue.100}' },
          subtle: { value: '{colors.hep_blue.200}' },
          emphasized: { value: '{colors.hep_blue.300}' },
          focusRing: { value: '{colors.hep_blue.500}' },
        },
        hep_orange: {
          solid: { value: '{colors.hep_orange.500}' },
          contrast: { value: '{colors.hep_orange.100}' },
          fg: { value: '{colors.hep_orange.700}' },
          muted: { value: '{colors.hep_orange.100}' },
          subtle: { value: '{colors.hep_orange.200}' },
          emphasized: { value: '{colors.hep_orange.300}' },
          focusRing: { value: '{colors.hep_orange.500}' },
        },
        hep_green: {
          solid: { value: '{colors.hep_green.500}' },
          contrast: { value: '{colors.hep_green.100}' },
          fg: { value: '{colors.hep_green.700}' },
          muted: { value: '{colors.hep_green.100}' },
          subtle: { value: '{colors.hep_green.200}' },
          emphasized: { value: '{colors.hep_green.300}' },
          focusRing: { value: '{colors.hep_green.500}' },
        },
      },
    },
  },
})

export const system = createSystem(defaultConfig, config)
